import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ChartOptions, ChartType, ChartDataSets, Chart } from "chart.js";
import { SharedService } from "../../../shared/services/shared.service";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { environment } from "../../../../environments/environment";
import { Notification } from "../../../core/helpers/notification";
import { ErrorHandlers } from "../../../core/helpers/errorhandlers";
import { Transaction } from "../dashaboard/model";

@Component({
  selector: "app-dashboard-gh",
  templateUrl: "./dashboard-gh.component.html",
  styleUrls: ["./dashboard-gh.component.css"],
})
export class DashboardGHComponent implements OnInit {
  constructor(
    private sharedserv: SharedService,
    private tokenservice: TokenService,
    private notservice: Notification,
    private err: ErrorHandlers,
    private cdr: ChangeDetectorRef
  ) {}
  datareq = new DataReq();
  days = 30;
  userLocalDetails;
  customLink: string;
  successfulValue = 0.0;
  successfulVolume = 0.0;
  settlementValue = 0.0;
  settlementVolume = 0.0;
  doughtData = [];
  doughlabel = [];
  defaultCurrency = "GHS";
  TxnSumm;
  SettSum;

  transactions: Transaction;

  settlements: Transaction;

  ngOnInit() {
    // this.barChartLabels = [
    //   "2025-05-08",
    //   "2025-05-13",
    //   "2025-05-14",
    //   "2025-05-16",
    //   "2025-06-24",
    //   "2025-07-11",
    // ];
    // this.barChartData = [
    //   {
    //     data: [0.1, 0.1, 2.2, 0, 0, 1],
    //     label: "Transaction Value",
    //   },
    // ];
    this.datareq.maxTransactionDate = new Date().toISOString().substring(0, 10);
    this.userLocalDetails = this.tokenservice.getUserCred();
    this.onDateChange(this.days);
    // this.getUserDefaultLink();
  }

  onDateChange(e) {
    let searchDate = new Date().getTime() - 86400000 * e;
    this.datareq.minTransactionDate = new Date(searchDate)
      .toISOString()
      .substring(0, 10);
    this.getDashboardData();
  }

  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: { position: "top" },

    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [
        {
          beginAtZero: true,
          type: "time",
          time: {
            unit: "day",
            displayFormats: {
              day: "MMM D",
            },
          },
          ticks: {
            autoSkip: false, // prevents skipping labels
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
      },
    },
  };
  barChartLabels = [];
  barData = [];
  barlabels = [];
  barChartType: ChartType = "bar";
  barChartLegend = true;

  barChartData: ChartDataSets[] = [
    {
      data: [],
      label: "Transaction Value",
    },
  ];

  bckcolor = [
    {
      backgroundColor: "#399918",
    },
  ];

  // doughnut
  Doughchart = [];

  configDoughChart() {
    this.doughlabel =
      this.doughlabel.length > 0 ? this.doughlabel : ["CARD", "MOMO"];
    this.Doughchart = new Chart("canvas", {
      type: "doughnut",
      data: {
        labels: this.doughlabel,
        datasets: [
          {
            data: this.doughtData.length > 0 ? this.doughtData : [0, 0],
            backgroundColor: ["#B0CE88", "#FFFD8F", "#CADCAE", "#EDA35A"],
          },
        ],
      },
      options: {
        legend: {
          display: true,
          position: "right",
        },
      },
    });
  }

  getDashboardData() {
    this.sharedserv.getDashBoardData(this.datareq.minTransactionDate).subscribe(
      async (data) => {
        this.constructDoughData_Summary(
          await data["summary"]["paymentChannel"]
        );
        this.transactions = data.summary.transactions[0];
        this.settlements = data.summary.settlements[0];
        this.constructBar_summary(await data["details"]);
        this.cdr.detectChanges();
      },
      (eror) => {
        this.configDoughChart();
      }
    );
  }

  separateSummaryTxnType(summary) {
    //  const avaiCurrency = ['USD','NGN','GHS'];
    let usdTxnSumm;
    let ghanaTxnSumm;
    for (let a = 0; a < summary.length; a++) {
      if (summary[a]["currency"] == "GHS") {
        ghanaTxnSumm = summary[a];
      } else if (summary[a]["currency"] == "USD") {
        usdTxnSumm = summary[a];
      }
    }
    this.TxnSumm = this.defaultCurrency == "GHS" ? ghanaTxnSumm : usdTxnSumm;
  }

  separateSummarySettlementType(summary) {
    //  const avaiCurrency = ['USD','NGN','GHS'];
    let ghanaSettSumm;
    let usdSettSumm;
    for (let a = 0; a < summary.length; a++) {
      if (summary[a]["currency"] == "GHS") {
        ghanaSettSumm = summary[a];
      } else if (summary[a]["currency"] == "USD") {
        usdSettSumm = summary[a];
      }
    }
    this.SettSum = this.defaultCurrency == "GHS" ? ghanaSettSumm : usdSettSumm;
  }

  constructDoughData_Summary(res) {
    this.doughtData = [];
    this.doughlabel = [];
    let doughGhs = [];
    let doughUsd = [];
    let doughGhsLabel = [];
    let doughUsdLabel = [];
    let arrHolder = [];
    let doughLabel = [];

    for (let y = 0; y < res.length; y++) {
      doughGhs.push(res[y].successValue);
      if (res[y].channel !== "DEFAULT") {
        doughGhsLabel.push(res[y].channel);
      }
      doughLabel = doughGhsLabel.map((label) => {
        return label === "USSD" ? "MOMO" : label;
      });
    }

    if (this.defaultCurrency == "GHS") {
      this.doughlabel = doughLabel;
      this.doughtData = doughGhs;
    } else {
      this.doughlabel = doughUsdLabel;
      this.doughtData = doughUsd;
    }

    this.configDoughChart();
  }

  constructBar_summary(res) {
    this.barlabels = [];
    this.barData = [];
    let barghlabel = [];
    let barghdata = [];
    let barusdlabel = [];
    let barusddata = [];
    let C = [];
    let arrHolder = res["transactions"];

    for (let a = 0; a < arrHolder.length; a++) {
      barghlabel.push(arrHolder[a].transactionDate);
      barghdata.push(arrHolder[a].successValue);
      this.cdr.detectChanges();

      // if (arrHolder[a]["currency"] == "GHS") {

      // } else if (arrHolder[a]["currency"] == "USD") {
      //   barusdlabel.push(arrHolder[a].transactionDate);
      //   barusddata.push(arrHolder[a].successValue);
      // }
    }
    this.barData = this.defaultCurrency == "GHS" ? barghdata : barusddata;
    this.barlabels = this.defaultCurrency == "GHS" ? barghlabel : barusdlabel;

    this.barChartLabels = [...this.barlabels];
    this.barChartData = [
      {
        data: [...this.barData],
        label: "Transaction Value",
      },
    ];

    this.cdr.markForCheck();
  }

  getUserDefaultLink() {
    this.sharedserv.getPaymentPages(this.userLocalDetails.clientId).subscribe(
      async (data) => {
        let isCustomLink = await this.checkCustomLink(data["data"]);
        this.customLink = isCustomLink
          ? `${environment.ghPaymentPageLink}${this.checkCustomLink(
              data["data"]
            )}`
          : "";
      },
      (error) => {
        this.err.customclienterrors(
          "Failed",
          error.status,
          error.error.responseMessage
        );
      }
    );
  }

  //return the first link called default payment link
  checkCustomLink(val) {
    let a = val.find((e) => {
      return e.pageName == "Default Custom Link";
    });
    return a ? a.customLink : null;
  }

  copyToClipboard(value) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", `${this.customLink}`);
      e.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    this.notservice.Success("Payment Link Copied");
  }

  copyDirect(value) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", `${value}`);
      e.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
    this.notservice.Success("Payment Link Copied");
  }

  setNewCurrency(e) {
    this.defaultCurrency = e;
    this.getDashboardData();
  }
}

export class DataReq {
  minTransactionDate: string;
  maxTransactionDate: string;
  settlement: boolean;
  paymentChannel: boolean;
  transactionType: boolean;
  constructor() {
    this.paymentChannel = true;
    this.transactionType = true;
    this.settlement = true;
  }
}
